export default "__VITE_ASSET__0e31df5a__"